import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LMicrophone = ({ isSpeaking, isRecording }: LMicrophoneProps): JSX.Element => {
    const renderMicIcon = (): JSX.Element => {
        if (isRecording) {
            return <FontAwesomeIcon icon={solid("microphone")} />;
        } else {
            return <FontAwesomeIcon icon={solid("microphone-slash")} />;
        }
    };

    return <div className={isSpeaking ? "has-text-success" : "has-text-black"}>{renderMicIcon()}</div>;
};

interface LMicrophoneProps {
    isSpeaking: boolean;
    isRecording?: boolean;
}
